import { useCallback } from 'react';
import LogRocket from 'logrocket';

import type { FreightProviderTrackingSlug } from './use-track-freight-connect-existing-clicked';

const logRocketFreightConnectSucceededEventName = 'FREIGHT_CONNECT_SUCCEEDED';

export const useTrackFreightConnectSucceeded = (): ((provider: FreightProviderTrackingSlug) => void) => {
  return useCallback((provider: FreightProviderTrackingSlug) => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightConnectSucceededEventName, { env: environment, provider });
  }, []);
};
